import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import { merge, each } from 'Utils/lodashUtils';
import { findItem } from 'Components/forms/select-input';
import FilterElement from 'Components/FilterElement';
import PrimaryButton from 'Components/Button/PrimaryButton';
import TableCheckbox from 'Components/TableCheckbox/TableCheckbox.jsx';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import counterpart from 'counterpart';
import HollowClearButton from 'Components/Button/HollowClearButton';
import Button from 'Components/Button/Button';
import TriangleDown from 'Components/icons/TriangleDown/TriangleDown';
import TriangleUp from 'Components/icons/TriangleUp/TriangleUp';
import WizardAccordion from 'Components/wizard-accordion/WizardAccordion';
import GlobalSelector from 'Containers/GlobalSelector';
import * as types from 'Utils/alertKeys';
import { normalizeDateFilters } from 'Utils/reports/reportFilterUtils';
import { validateFiltersAgainstValidationRule } from 'Utils/validationUtils';
import './FilterPane.scss';
import SingleListSelector from 'Components/SingleListSelector';
import DashedButton from 'Components/Button/DashedButton';
import mapInitialColumns from 'Utils/reports/mapInitialColumns';
import OutsideClickHandler from 'Components/OutsideClickHandler';
import ResponseBanner from 'Components/cards/ResponseBanner';
import ImagePortal from 'Containers/ImagePortal';
import {
  sortColumnsByInt,
} from 'Utils/dualListSelectorUtils';
import GlobalSelectorAccounts from '../../../app/src/containers/GlobalSelector/GlobalSelectorAccounts';
import { COLORS } from "Constants/BIDashboardConstants"

class FilterPane extends Component {
  constructor(props) {
    super(props);

    this.scrollFilterClose = this.scrollFilterClose.bind(this);

    const showMoreFilters = false; // always start by only showing first 8 filters
    const normalizedValues = normalizeDateFilters(props.filterList, props.currentValues, props.dateFormat, this.props.showDynamicFilter);
    const currentValuesObj = normalizedValues.reduce((obj, value) => {
      return Object.assign(obj, {
        [value.id]: {
          v1: value.v1,
          v2: value.v2,
          type: value.type,
          error: value.error,
          flag: value.flag,
        },
      });
    }, {});

    this.state = {
      selectedCardType: null,
      currentValues: currentValuesObj,
      filtersCount: this.props.filterList.length,
      selectedItem: this.props.filterList[0],
      showMoreFilters,
      sortedFilterList: this.getCurrentlyShownFilters(props.filterList, showMoreFilters),
      visibleCount: props.filterList.length,
      isSingleListSelectorOpen: false,
      currentActiveColumns: [],
      availableFilters: this.props.availableFilters,
      isExpanded: false,
      visible: false,
      currentSearchTerm: '',
      selectedReasonCode: [],
      selectedCorpRegionCode: [],
      selectedActionCode: [],
      selectedReasonCodeCq: [],
      selectedActivityCode: [],
      selectedDispCategory: [],
      selectedDisputeCurr: [],
      selectedMccCode: [],
      selectedTransactionCurr: [],
      selectedSettlementCurr: [],
      selectedAnalystName: [],
      visibility: false,
      corp: [],
      region: [],
      corpRegion: [],
      scheduleButton: false,
      clearScheuldeFilters: true,
      existingScheduleFilters: [],
      isRequiredFilter: false,
      bannerDescription: "",
      isVisible: true,
      merchant_hierarchy:props.merchant_hierarchy,
      selectedRow:props.selectedRow,
      idr_disp_action_code : [],
      idr_activity_code : [],
      merch_disp_code : [],
      isRangeValidation : false,
      enableApplyButton: false,
      isArchival:false,
      roleName:  JSON.parse(sessionStorage.getItem("state")).auth.user.role.key,
    };
    this.attachBindings();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollFilterClose);
    this.defaultSelected();
  }

  componentWillReceiveProps(nextProps) {
   if(this.props.isInvBreReport){
    setTimeout(() => {
      this.setState(
        {}, () => this.setState({ enableApplyButton: this.applyButtonDisabledLogic() })
      )
    }, 550);
   }  
   if(this.props.isInvBreReport && this.props.applyAuto == true){
    this.applyFilters();
   }

    if(this.props.clearSearchTermValue == true){
      this.clearSearchTerm();
    }
    if (this.props.filterList.length != nextProps.filterList.length || (this.props.filterList && nextProps.filterList && JSON.stringify(this.props.filterList)!=JSON.stringify(nextProps.filterList)) || this.props.availableFilters.length !== nextProps.availableFilters.length) {
      const newSortedFilterList = this.getCurrentlyShownFilters(nextProps.filterList, this.state.showMoreFilters);
      this.setState({ sortedFilterList: newSortedFilterList, availableFilters: nextProps.availableFilters, visibleCount: nextProps.filterList.length });
      this.handleClickOutside();
   
    }
    const filertWithError = nextProps.currentValues.find((currentFilter) => {
      const r =
        currentFilter.error !== undefined;
      return r;
    },
    );

    if (nextProps.currentValues.length !== this.props.currentValues.length || filertWithError !== undefined || JSON.stringify(this.props.currentValues) !== JSON.stringify(nextProps.currentValues)) {
      const normalizedValues = normalizeDateFilters(nextProps.filterList, nextProps.currentValues, nextProps.dateFormat, nextProps.showDynamicFilter);
      const currentValuesObj = normalizedValues.reduce((obj, value) => {
        return value?Object.assign(obj, {
          [value.id]: {
            v1: value.v1,
            v2: value.v2,
            type: value.type,
            error: value.error,
            flag: value.flag,
          },
        }):{};
      }, {});

      if (nextProps.currentValues && this.props.currentValues && JSON.stringify(this.props.currentValues) !== JSON.stringify(nextProps.currentValues)) {
        this.setState({ currentValues: currentValuesObj });
      }
    }

  }

  componentDidUpdate() {

  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollFilterClose);
  }

  attachBindings() {
    this.openSingleListSelector = this.openSingleListSelector.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.removeFilterAction = this.removeFilterAction.bind(this);
    this.toggleSearchDropDown = this.toggleSearchDropDown.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.searchReasonCode = this.searchReasonCode.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleHeaderCheckbox = this.handleHeaderCheckbox.bind(this);
    this.updateMerchantList = this.updateMerchantList.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.clearSearchTerm = this.clearSearchTerm.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.setArchivalFlag=this.setArchivalFlag.bind(this);
  }

  getCurrentlyShownFilters = (filters, showAll) => {
    const visibleFilters = filters
      // .filter((filter) => filter.isVisible)
      .map((filter) => {
        if (filter.elementId === 'corpregion') {
          return Object.assign({}, filter, {
            id: filter.elementId,
            placeHolder: this.props.translations.corpAndRegion
          });
        } else if (filter.elementId === 'reason_code' || filter.elementId == 'cq_reason_code') {
          return Object.assign({}, filter, {
            id: filter.elementId,
            placeHolder: this.props.translations.reasonCode
          });
        } else if (filter.elementId == 'cq_action_code') {
          return Object.assign({}, filter, {
            id: filter.elementId,
            placeHolder: this.props.translations.actionCode
          });
        } else if (filter.elementId == 'cq_activity_code') {
          return Object.assign({}, filter, {
            id: filter.elementId,
            placeHolder: this.props.translations.activityCode
          });
        } else if (filter.elementId == 'cq_dispute_currency') {
          return Object.assign({}, filter, {
            id: filter.elementId,
            placeHolder: this.props.translations.disputeCurrency
          });
        } else if (filter.elementId == 'cq_trnsctn_currency') {
          return Object.assign({}, filter, {
            id: filter.elementId,
            placeHolder: this.props.translations.trnsctnCurrency
          });
        } else if (filter.elementId == 'cq_sttlmnt_crrncy') {
          return Object.assign({}, filter, {
            id: filter.elementId,
            placeHolder: this.props.translations.sttlmntCrrncy
          });
        } else if (filter.elementId == 'cq_dspstn_ctgry') {
          return Object.assign({}, filter, {
            id: filter.elementId,
            placeHolder: this.props.translations.dspstnCtgry
          });
        } else if (filter.elementId == 'cq_mcc') {
          return Object.assign({}, filter, {
            id: filter.elementId,
            placeHolder: this.props.translations.mcc
          });
        } else if (filter.elementId == 'un_analyst_name') {
          return Object.assign({}, filter, {
            id: filter.elementId,
            placeHolder: "Select Analyst Name"
          });
        } else {
          return Object.assign({}, filter, {
            id: filter.elementId
          });
        }

      });

    return (showAll)
      ? this.sortFilters(visibleFilters)
      : this.sortFilters(visibleFilters).slice(0, this.props.visibleFiltersCount);
  }

  handleSingleSelection = (value, event) => {
    event.stopPropagation();

    const field = this.findDataAttribute(event.target);

    if (field) {
      const findFilterList = this.props.filterList.filter((filter) => {
        return filter.elementId === field;
      });
      const foundFilter = findFilterList.shift();

      if (foundFilter) {
        const newSelection = findItem(foundFilter.filterValues, value);
        const newValues = Object.assign({}, this.state.currentValues, {
          [field]: { v1: value },
        });
        if (newSelection) {
          this.setState({ currentValues: newValues });
        }
      }
    } else {
      throw new Error('Could not find numeric filter ID on DOM target, parent or grandparent');
    }
  }
  handleSingleDateChange = (id, value) => {
    let newValue;
    const valueFound = false;

    if (valueFound === false) {
      newValue = Object.assign({},  this.state.currentValues,{
        [id]: { v1: moment(value).format('MM/DD/YYYY') },
      });
    }

    this.setState({
      currentValues: newValue,
    });
  }

  findDataAttribute(domNode) {
    // let name = domNode.dataset.name;
    let name = domNode.getAttribute('data-name');

    if (!name) {
      name = domNode.parentElement.getAttribute('data-name');
      // name = domNode.parentElement.dataset.name;
    }

    if (!name) {
      // name = domNode.parentElement.parentElement.dataset.name;
      name = domNode.parentElement.parentElement.getAttribute('data-name');
    }
    if (!name) {
      name = domNode.id;
    }

    return name;
  }
  defaultSelected =() =>{
    let userMXPermissions = JSON.parse(sessionStorage.getItem('state')).auth.user.parsedPermissions.queue.viewMxQueues;
    let userGPPermissions = JSON.parse(sessionStorage.getItem('state')).auth.user.parsedPermissions.queue.viewGPNQueues;
   let userHPYPermissions = JSON.parse(sessionStorage.getItem('state')).auth.user.parsedPermissions.queue.viewHPYQueues ;   
   let userEVOPermission  = JSON.parse(sessionStorage.getItem('state')).auth.user.parsedPermissions.queue.viewEvoQueues;
   let selectedItems="";
      const arr=[];
        if (userGPPermissions || userMXPermissions){
          arr.push("GPN");
      }
        if(userHPYPermissions){
          arr.push("HPY");
       }
       if(userEVOPermission){
          arr.push("EVO");
       }
       if(arr.length>0){
        selectedItems={"acquirerCode" : { "v1":arr}};
         this.setState({
           currentValues: merge(this.state.currentValues, selectedItems),
         });
       }
}

  secondFieldHandleSection = (value, event) => {
    const field = this.findDataAttribute(event.target);
    event.stopPropagation();
    if (field) {
      const findFilterList = this.props.filterList.filter((filter) => {
        return filter.elementId === field;
      });

      const foundFilter = findFilterList.shift();

      if (foundFilter) {
        let crValue = this.state.currentValues[field];
        const newSelection = findItem(foundFilter.filterValuesSecondField, value);
        let currentMultiSelectValue = [];
        currentMultiSelectValue = (crValue?.v2)
          ? crValue?.v2
          : [];

        const selectedItemsIndex = (currentMultiSelectValue)
          ? currentMultiSelectValue.indexOf(value) : null;

        if (selectedItemsIndex !== -1) {
          currentMultiSelectValue?.splice(selectedItemsIndex, 1);
        } else {
          currentMultiSelectValue.push(newSelection.value);
        }


        const newValues = Object.assign({}, this.state.currentValues, {
          ...this.state.currentValues,
          [field]: { v1: this.state.currentValues[field]?.v1, v2: currentMultiSelectValue },
        });

        if (newSelection) {
          this.setState({
            currentValues: newValues,
          });
        }
        this.props.onFilterValueChange(newValues)
      }
    } else {
      throw new Error('Could not find numeric filter ID on DOM target, parent or grandparent');
    }

  }

  handleSelection = (value, event) => {
    event.stopPropagation();
    const field = this.findDataAttribute(event.target);
    if (field) {
      const findFilterList = this.props.filterList.filter((filter) => {
        return filter.elementId === field;
      });

      const foundFilter = findFilterList.shift();

      if (foundFilter) {
        let crValue = this.state.currentValues[field];
        const newSelection = findItem(foundFilter.filterValues, value);
        let currentMultiSelectValue = [];
        currentMultiSelectValue = (crValue?.v1)
          ? crValue?.v1
          : [];

        const selectedItemsIndex = (currentMultiSelectValue)
          ? currentMultiSelectValue.indexOf(value) : null;

        if (selectedItemsIndex !== -1) {
          currentMultiSelectValue?.splice(selectedItemsIndex, 1);
        } else {
          currentMultiSelectValue?.push(newSelection.value);
        }


        const newValues = Object.assign({}, this.state.currentValues, {
          ...this.state.currentValues,
          [field]: { v1: currentMultiSelectValue, v2: this.state.currentValues[field]?.v2 },
        });
        if (newSelection) {
          this.setState({
            currentValues: newValues,
          });
        }
        this.props.onFilterValueChange(newValues)
      }
    } else {
      throw new Error('Could not find numeric filter ID on DOM target, parent or grandparent');
    }
  }


  sortFilters = (filterList = []) => {
    return filterList.sort((filterA, filterB) => {
      return Number(filterA.elementSequenceNumber) - Number(filterB.elementSequenceNumber);
    });
  }

  get displayFilterList() {
    const excludedValues = ["merchant_hierarchy"];
    const excludedValuesMigratedUser = ["merchant_hierarchy", "chain", "group", "tax_id", "merchant_number", "corporate", "region", "principal", "associate"];   
    const allowedMigratedHierarchyRoles = ["DiMS_ACQUIRER_ADMIN", "DiMS_ACQUIRER_USER", "DiMS_INTERNAL_EMPLOYEE"];    
    const isMigratedUserRoleKey = allowedMigratedHierarchyRoles.indexOf(this.state.roleName) !== -1;
    return this.searchFilterList(((this.props.canViewGpnAccountsSelector || this.props.canViewEvoAccountsSelector||this.props.canViewHpyAccountsSelector) && isMigratedUserRoleKey) ? excludedValuesMigratedUser : excludedValues);
  }

  searchFilterList(excludedValues) {
    return this.state.sortedFilterList && this.state.sortedFilterList.length !== 0 && this.state.sortedFilterList.filter(filtr => !excludedValues.includes(filtr.elementId)).map((filter, index) => {
      return (
        <FilterElement
          searchWithFullPan={filter.elementTypeName === 'FULL_CC_NUMBER' ? this.props.userPermission && this.props.userPermission.case.searchWithFullPan : true}
          currentValues={this.state.currentValues[this.props.showDynamicFilter ? filter.updatedId : filter.elementId]}
          dateFormat={this.props.dateFormat}
          filter={filter}
          handleDualDates={this.handleDualDates}
          handleMonthChange={this.handleMonthChange}
          handleSelection={this.handleSelection}
          secondFieldHandleSection={this.secondFieldHandleSection}
          defaultSelected={this.defaultSelected}
          handleSingleSelection={this.handleSingleSelection}
          key={index}
          currentSearchTerm={this.state[filter.elementId]}  //defect id 45 => for value getting autometically added for reason code field
          onChange={this.updateFormState}
          onCurrencyChange={this.updateCurrencyState}
          onRangeChange={this.handleRangeChange}
          translations={this.props.translations}
          id={`${this.props.reportName}_filterElement`}
          language={this.props.language}
          reportKey={this.props.reportKey}
          onSingleDateChange={this.handleSingleDateChange}
          extraClass={this.props.appSearchElement}
          removeFilterAction={this.removeFilterAction}
          showDynamicFilter={this.props.showDynamicFilter}
          updatedId={filter.updatedId}
          handleOutsideClick={this.handleOutsideClick}
          toggleCollapse={this.toggleCollapse}
          toggleSearchDropDown={this.toggleSearchDropDown}
          searchReasonCode={this.searchReasonCode}
          visible={this.state.visible}
          handleChange={this.handleChange}
          handleHeaderCheckbox={this.handleHeaderCheckbox}
          updateIsIndeterminate={this.props.updateIsIndeterminate}
          //currentSearchTerm={this.state.currentSearchTerm} 
          isMerchantUser={this.props.isMerchantUser}
          listHeight={this.props.listHeight}
          index={this.state.index}
          removeTopMargin={this.props.removeTopMargin}
          reportName={this.props.reportName}
          isArchival={this.state.isArchival}
          showRemoveLabel = {this.props.showRemoveLabel}
        />
      );
    });
  }

  removeFilterAction(identifier) {
    this.props.disableSaveButton();
    const { availableFilters, sortedFilterList } = this.state;
    const columnToMove = sortedFilterList.find((column) => column.updatedId === identifier);
    if (columnToMove) {
      const newActiveColumns = sortedFilterList
        .filter((column) => column.updatedId !== identifier);
      let newAvailableColumns = availableFilters;
      
        newAvailableColumns = sortColumnsByInt([...availableFilters, columnToMove], 'elementSequenceNumber')
      
      this.state.sortedFilterList.map((element) => {
        if (element.elementTypeName === 'GROUP_SEARCH') {
          if (element.elementId == identifier) {
            for (let i = 0; i < element.filterValues.length; i++) {
              element.filterValues[i].selected = false;
              let items = element.filterValues[i].items;
              for (let j = 0; j < items.length; j++) {
                items[j].selected = false;
              }
            }
          }
        }
      })
      //remove values from current state for deleted element
      let updatedCurrentValues = Object.fromEntries(
        Object.entries(this.state.currentValues).filter(([key]) => key !== identifier)
      );
      this.setState({
        availableFilters: newAvailableColumns,
        sortedFilterList: newActiveColumns,
        [identifier]: "",
        currentSearchTerm: '',
        currentValues: updatedCurrentValues,
        selectedReasonCodeCq: identifier == "cq_reason_code" ? [] : this.state.selectedReasonCodeCq
      }, () => {
        this.props.updateColumnsInfo({
          availableColumns: newAvailableColumns,
          activeColumns: newActiveColumns,
          identifier,
          currentValues: this.state.currentValues,
          filterList: this.props.filterList,
        });
      });
    }
  }

  /**
   * handler called by STRING type filters to update the input value in state
   * @param    {Event} event standard synthetic React event wrapper around DOM event
   * @modifies {state}       updates the matching value in currentValues array in component state
   *
   * @description each value object for a STRING looks like this:
   *                {"id":267, "v1":"last_year", "type":"EXACT"}
   *                where id = filter ID
   *                      v1 = the single value
   *                      type = match type
   */
  updateFormState = (event) => {
    const field = event.target.name;
    const value = event.target.value ? event.target.value : event.target.value;
    const newValues = Object.assign({}, this.state.currentValues, {
      [field]: { v1: value },
    });

    if (value === '') { delete newValues[field]; }
    const regex= /^[0-9]{0,2}$/;
    if (field == 'pos_entry_mode' && value.match(regex)){
      this.setState({
        currentValues: newValues,
      },
      ()=> {
        if(this.props.isInvBreReport) 
        this.setState({ enableApplyButton: this.applyButtonDisabledLogic() })
      }
      );
    }
    if (field != 'pos_entry_mode') {
      this.setState({
        currentValues: newValues,
      },
      ()=> {
        if(this.props.isInvBreReport) 
        this.setState({ enableApplyButton: this.applyButtonDisabledLogic() })
      }
      );
    }
  }

  /**
   * handler called by CURRENCYEXACT type filter/s to update the input value in state
   * @param    {Event} event standard synthetic React event wrapper around DOM event
   * @modifies {state}       updates the matching value in currentValues array in component state
   * NOTE : Need this handler as string update event takes different parameters as compared to CURRENCEXACT.
   *        Since it is a generic component and is used in multiple places, thi code is required
   * @description each value object for a CURRENCYEXACT looks like this:
   *                {"id":267, "v1":"last_year", "type":"CURRENCYEXACT"}
   *                where id = filter ID
   *                      v1 = the single value
   *                      type = match type
   */
  updateCurrencyState = (value, id) => {
    value = value ? value.trim() : value;

    const newValues = Object.assign({}, this.state.currentValues, {
      [id]: { v1: value },
    });
    if (value === '') { delete newValues[id]; }

    this.setState({
      currentValues: newValues,
    });
  }

  /**
   * handler called by Range type filters (CURRENCY, DATE) to update the input value in state
   * @param    {number} id       the database ID of the matching filter
   * @param    {string} selector 'start' for the first value (v1),'end' for second value (v2)
   * @param    {string} value    the value to use
   * @modifies {state}           updates the matching value in currentValues array in component state
   *
   * @description each value object for a STRING looks like this:
   *                {"id":267, "v1":"last_year", "type":"EXACT"}
   *                where id = filter ID
   *                      v1 = the single value
   *                      type = match type
   */
  handleRangeChange = (id, selector, value) => {
    const key = (selector === 'end') ? 'v2' : 'v1';
    const currentRange = (this.state.currentValues[id]) || {};
    const newValue = value.trim() === '' ? undefined : value.trim();

    // set newRange to undefined if v1 and v2 are both undefined
    let newRange = Object.assign(currentRange, { [key]: newValue });
    if (newRange.v1 === undefined && newRange.v2 === undefined) {
      newRange = undefined;
    }

    // update newValues
    let newValues = Object.assign({}, this.state.currentValues, {
      [id]: newRange,
    });

    // remove id key from newValues if newRange is undefined > cleanup newValues
    const ids = this.state.currentValues[id];
    if (ids !== undefined && newRange === undefined) {
      const { [id.toString()]: omit, ...rest } = newValues;
      newValues = rest;
    }

    const currentId = newValues[id];
    if (currentId !== undefined && ((currentId.v1 === null && currentId.v2 === null) ||
      (currentId.v1 === '' && currentId.v2 === ''))) {
      delete newValues[id];
    }

    this.setState({
      currentValues: newValues,
    });
  }

  handleDualDates = (id, dualValues) => {
    this.props.deleteAlertPrefsByAlertkey(types.REPORT_VALIDATION);
    // find or create filter values obj
    const targetValues = (this.state.currentValues[id]) || {};
    // copy current values
    const newValues = Object.assign({}, this.state.currentValues, {
      [id]: targetValues,
    });

    // decide type
    if (dualValues.startDate && dualValues.endDate) {
      targetValues.type = 'BETWEEN';
    } else if (dualValues.startDate) {
      targetValues.type = 'STARTS_WITH';
    } else if (dualValues.endDate) {
      targetValues.type = 'ENDS_WITH';
    } else {
      targetValues.type = 'DELETE';
    }
    if (targetValues.type === 'DELETE') {
      // remove obj if both values are missing
      delete newValues[id];
    } else {
      // otherwise, update to new values
      // const target = newValues[id];
      targetValues.v1 = dualValues.startDate;
      targetValues.v2 = dualValues.endDate;
    }
    targetValues.error = '';
    targetValues.flag = false;
    const currentCalenderValues = [{ id, v1: dualValues.startDate, v2: dualValues.endDate, type: targetValues.type }];
    validateFiltersAgainstValidationRule(this.props.filterList, currentCalenderValues,
      this.props.dateFormat).then((currentValues) => {
        const modfiedObject = currentValues.find((currentValue) => {
          return id === currentValue.id;
        });
        if(this.props.reportId === '7' || this.props.reportId === '8' || this.props.reportId === '9')  {
          const fromDate = new Date(modfiedObject.v1);
          const ToDate = new Date(modfiedObject.v2);
          const oneDay = 1000 * 60 * 60 * 24;
          const diffInTime = ToDate.getTime() - fromDate.getTime();
          const diffInDays = Math.round(diffInTime / oneDay);
          if(diffInDays > 45) {
            this.setState({
              isRangeValidation : true,
            });
          }
        }
        if (modfiedObject.error) {
          Object.assign(targetValues, {
            error: modfiedObject.error,
            flag: modfiedObject.flag,
          });
          this.props.setAlertPrefs([{
            showAlert: true,
            msgAlertType: 'danger',
            displayText: targetValues.error,
            alertKey: types.REPORT_VALIDATION,
          }]);
        } 
        this.setState({
          currentValues: newValues,
        });
      });
  }

  handleMonthChange = (id, value) => {
    const targetValues = (this.state.currentValues[id]) || {};
    targetValues.v1 = value;

    // copy current values
    const newValues = Object.assign({}, this.state.currentValues, {
      [id]: targetValues,
    });

    this.setState({
      currentValues: newValues,
    });
  }

  toggleFilters = () => {
    const newShowStatus = !this.state.showMoreFilters;
    const newSortedFilterList = this.getCurrentlyShownFilters(this.props.filterList, newShowStatus);
    this.setState({
      showMoreFilters: newShowStatus,
      sortedFilterList: newSortedFilterList,
    });
    if(document.getElementById('case-body')){
    if (newShowStatus === true) {
      document.getElementById('case-body').style.maxHeight = '286px';
    } else {
      document.getElementById('case-body').style.maxHeight = '200px';
    }
  }
  }
  
  clearSearchTerm = () => {
    this.setState({
      reason_code: "",
      corpregion: "",
      selectedReasonCode: [],
      selectedCorpRegionCode: [],
      selectedActionCode: [],
      selectedReasonCodeCq: [],
      selectedActivityCode: [],
      selectedDispCategory: [],
      selectedDisputeCurr: [],
      selectedMccCode: [],
      selectedTransactionCurr: [],
      selectedSettlementCurr: [],
      idr_disp_action_code : [],
      idr_activity_code : [],
      merch_disp_code : [],
      selectedAnalystName:[]
    });
  }
  
  clearFilters = () => {
    this.setState({
      currentValues: [],
      currentSearchTerm: '',
      corpregion: "",
      reason_code: "",
      merchantHierarchyRest:true,
      selectedReasonCode: [],
      selectedCorpRegionCode: [],
      selectedActionCode: [],
      selectedReasonCodeCq: [],
      selectedActivityCode: [],
      selectedDispCategory: [],
      selectedDisputeCurr: [],
      selectedMccCode: [],
      selectedTransactionCurr: [],
      selectedSettlementCurr: [],
      idr_disp_action_code : [],
      idr_activity_code : [],
      merch_disp_code : [],
      selectedAnalystName: [],
      isArchival:false
    });

      
   this.props.clearAllFilters();
   
    this.state.sortedFilterList.map((element) => {
      if (element.elementTypeName === 'GROUP_SEARCH') {
        for (let i = 0; i < element.filterValues.length; i++) {
          element.filterValues[i].selected = false;
          let items = element.filterValues[i].items;
          for (let j = 0; j < items.length; j++) {
            items[j].selected = false;
          }
        }
      }
    })
  }

  closeTempBanner= () =>{
    this.setState({
      tempVariable : false,

    });
  }

  applyFilters = () => {

    if ((this.state.currentValues['hpy_petro_name']?.v1.length > 0 || this.state.currentValues['legal_name']?.v1.length > 0) &&
      !this.state.currentValues['case_rcvd_from_date-case_rcvd_to_date']?.v1.length > 0) {
      this.setState({
        tempVariable: true,
        bannerDescription: `Case Received Date is required for searching with filters Legal Name or HPY Petro Name`,
      });
    }
    else {
      let pr_event_type = this.state.currentValues?.pr_event_type;
      let currentValues = this.state.currentValues
      if (pr_event_type != null && !pr_event_type.v1.includes("action")) {
        currentValues = Object.assign({}, this.state.currentValues, {
          ["pr_action_type"]: { v1: [] },
        });
      }
      if(this.props.canViewEvoAccountsSelector || this.props.canViewGpnAccountsSelector||this.props.canViewHpyAccountsSelector){
        currentValues = {
          ...this.state.currentValues,
          row : this.state.selectedRow,
      }
      }
      if (this.props.canViewHierarchySelector) {
        let merchant_hierarchy = Object.assign({}, this.state.merchant_hierarchy);
        this.state.currentValues.merchant_hierarchy = merchant_hierarchy;
      }
       this.props.applyFilters(currentValues, this.props.filterList, this.state.corp, this.state.region, this.state.corpRegion,this.state.isArchival);

      if (this.state.showMoreFilters) {
        this.toggleFilters();
      }
    }
  }

  saveAndApplyFilters = () => {
    this.props.saveAndApplyFilters();
  }

  scrollFilterClose() {
    const filterElement = document.getElementById('filter-pane');
    const trigger = filterElement.getBoundingClientRect().top + filterElement.offsetHeight;

    if (trigger <= 140) {
      this.props.resetScrollPos();
      this.props.closeFilterPane();
    }
    // this.props.setSearchType(undefined);
  }

  openSingleListSelector() {
    this.setState((prevState) => ({
      isSingleListSelectorOpen: !prevState.isSingleListSelectorOpen
    }))
  }

  handleClickOutside() {
    this.setState({
      isSingleListSelectorOpen: false
    })
  }

  handleOnApplyActiveColumns = (newAvailableColumns, newActiveColumns) => {
    this.setState({
      availableColumns: newAvailableColumns,
      activeColumns: newActiveColumns,
      currentActiveColumns: newActiveColumns,
    }, () => {
      this.props.updateVisibleColumns(newActiveColumns);
    });
  }

  handleOnUpdateActiveColumns = (columns) => {
    this.setState({
      currentActiveColumns: columns,
    });
  }

  handleChange(item, filterName) {
    let newSelection = [];
    let newValues = [];
    let region = [];
    let corp = [];
    let corpRegion = [];
    item.selected = !item.selected;
    let selectedReasonCode = this.state.selectedReasonCode ? this.state.selectedReasonCode : [];
    let selectedCorpRegionCode = this.state.selectedCorpRegionCode ? this.state.selectedCorpRegionCode : [];
    let reasonCodeFilters = this.state.sortedFilterList.find(sortedFilter => sortedFilter.elementId == 'reason_code');
    if ((filterName == 'cq_reason_code' || (filterName == 'reason_code' && reasonCodeFilters.elementSequenceNumber !== 9 && reasonCodeFilters.elementSequenceNumber !== 14))  &&  !item.value.includes('-')) {
      item.value = item.value + "-" + item.groupId
      item.id = item.id + "-" + item.groupId
    }
    if ((filterName == 'cq_reason_code' || filterName == 'reason_code')  &&  !item.value.includes('-')) {
      item.value = item.value + "-" + item.groupId
      item.id = item.id + "-" + item.groupId
    }
    if (filterName == 'cq_reason_code'|| (filterName == 'reason_code' && reasonCodeFilters.elementSequenceNumber == 5)) {
      newSelection = this.handleChangeCommon(item, filterName, 'selectedReasonCodeCq')
    }
    if (filterName == 'cq_action_code') {
      newSelection = this.handleChangeCommon(item, filterName, 'selectedActionCode');
    }
    if (filterName == 'cq_activity_code') {
      newSelection = this.handleChangeCommon(item, filterName, 'selectedActivityCode');
    }
    if (filterName == 'cq_dspstn_ctgry') {
      newSelection = this.handleChangeCommon(item, filterName, 'selectedDispCategory');
    }
    if (filterName == 'cq_dispute_currency') {
      newSelection = this.handleChangeCommon(item, filterName, 'selectedDisputeCurr');
    }
    if (filterName == 'cq_mcc') {
      newSelection = this.handleChangeCommon(item, filterName, 'selectedMccCode');
    }
    if (filterName == 'cq_trnsctn_currency') {
      newSelection = this.handleChangeCommon(item, filterName, 'selectedTransactionCurr');
    }
    if (filterName == 'cq_sttlmnt_crrncy') {
      newSelection = this.handleChangeCommon(item, filterName, 'selectedSettlementCurr');
    }
    if (filterName == 'idr_disposition') {
      newSelection = this.handleChangeCommon(item, filterName, 'idr_activity_code');
    }
    if (filterName == 'merchant_dspn_actn') {
      newSelection = this.handleChangeCommon(item, filterName, 'merch_disp_code');
    }
    if (filterName == 'idr_action_code') {
      newSelection = this.handleChangeCommon(item, filterName, 'idr_disp_action_code');
    }
    if (filterName == 'un_analyst_name') {
      newSelection = this.handleChangeCommon(item, filterName, 'selectedAnalystName');
    }

    if (filterName !== 'corpregion' && filterName !== 'cq_reason_code' && (filterName == 'reason_code' && reasonCodeFilters.elementSequenceNumber !== 5) && filterName !== 'cq_action_code' && filterName !== 'cq_activity_code' && filterName !== 'cq_dspstn_ctgry' && filterName !== 'cq_dispute_currency' && filterName !== 'cq_mcc' && filterName !== 'cq_trnsctn_currency' && filterName !== 'cq_sttlmnt_crrncy' && filterName != 'un_analyst_name') {
      reasonCodeFilters.filterValues.map((filterValue) => {
        filterValue.items.map(filterItem => {
          if (filterItem.selected) {
            let filterIndex = selectedReasonCode.findIndex((selectedReasonCodeItem) => selectedReasonCodeItem.id == filterItem.id && selectedReasonCodeItem.groupId == filterItem.groupId);
            if (filterIndex == -1 && this.state.currentValues && this.state.currentValues.reason_code && this.state.currentValues.reason_code.v1 && this.state.currentValues.reason_code.v1.findIndex(val => val == filterItem.id) != -1) {
              selectedReasonCode = selectedReasonCode.concat(filterItem);
            }
          }
        })
      })
      selectedReasonCode = Array.from(new Set(selectedReasonCode));

      if (item.selected) {
        let numberOfRecordsToAssign = 0;
        selectedReasonCode.forEach(selectedUser => {
          if (selectedUser.userId === item.userId) {
            numberOfRecordsToAssign = selectedUser.numberOfRecordsToAssign;
          }
        });
        item.numberOfRecordsToAssign = numberOfRecordsToAssign;
        selectedReasonCode.push(Object.assign({}, item));
      } else if (item.userId && item.cardBrandName) {
        let index = selectedReasonCode.findIndex(o => o.userId == item.userId && o.cardBrandName == item.cardBrandName);
        if (index > -1) {
          selectedReasonCode.splice(index, 1);
        }
      } else {
        let reasonCodeIndex = selectedReasonCode.findIndex(o => o.id == item.id && o.groupId == item.groupId);
        if (reasonCodeIndex > -1) {
          selectedReasonCode.splice(reasonCodeIndex, 1);
        }
      }
    }

    if (filterName === 'corpregion') {
      if (item.selected) {
        let numberOfRecordsToAssign = 0;
        selectedCorpRegionCode.forEach(selectedUser => {
          if (selectedUser.userId === item.userId) {
            numberOfRecordsToAssign = selectedUser.numberOfRecordsToAssign;
          }
        });
        item.numberOfRecordsToAssign = numberOfRecordsToAssign;
        selectedCorpRegionCode.push(Object.assign({}, item));
      } else {
        let reasonCodeIndex = selectedCorpRegionCode.findIndex(o => o.id == item.id && o.groupId == item.groupId);
        if (reasonCodeIndex > -1) {
          selectedCorpRegionCode.splice(reasonCodeIndex, 1);
        }
      }

      newSelection = selectedCorpRegionCode.map((item) => {
        return `${item.groupId} - ${item.value}`;
      });
      corp = selectedCorpRegionCode.map((item) => {
        return item.groupId;
      });
      corp = corp.filter((x, i, a) => a.indexOf(x) == i)
      region = selectedCorpRegionCode.map((item) => {
        return item.value;
      });
      corpRegion = selectedCorpRegionCode.map((item) => {
        return { "corp": item.groupId, "region": item.value }
      });
      this.setState({
        corp: corp,
        region: region,
        corpRegion: corpRegion
      })
    } else if (filterName !== 'cq_reason_code' && (filterName == 'reason_code' && reasonCodeFilters.elementSequenceNumber !== 5)  && filterName !== 'cq_action_code' && filterName !== 'cq_activity_code' && filterName !== 'cq_dspstn_ctgry' && filterName !== 'cq_dispute_currency' && filterName !== 'cq_mcc' && filterName !== 'cq_trnsctn_currency' && filterName !== 'cq_sttlmnt_crrncy' && filterName != 'un_analyst_name'
     && filterName !== 'merchant_dspn_actn' && filterName !== 'idr_disposition' && filterName !== 'idr_action_code') {
      newSelection = selectedReasonCode.map((item) => {
        return item.value;
      });
    }

    newValues = Object.assign({}, this.state.currentValues, {
      [filterName]: { v1: newSelection },
    });
    this.setState({
      currentValues: newValues,
    });
  }

  handleChangeCommon = (item, filterName, filterState) => {
    let elementState = this.state[filterState] ? this.state[filterState] : [];
    let filterCodeFilters = this.state.sortedFilterList.find(sortedFilter => sortedFilter.elementId == filterName);
    let selectedItems = [];
    filterCodeFilters.filterValues.map((filterValue) => {
      filterValue.items.map(filterItem => {
        if (filterItem.selected) {
          selectedItems.push(filterItem);
          let filterIndex = elementState.findIndex((selectedCodeItem) => selectedCodeItem.id == filterItem.id && selectedCodeItem.groupId == filterItem.groupId);
          if (filterIndex == -1 && this.state.currentValues && this.state.currentValues[filterName] && this.state.currentValues[filterName].v1 && this.state.currentValues[filterName].v1.findIndex(val => val == filterItem.id) != -1) {
            elementState = elementState.concat(filterItem);
          }
        }
      })
    })
    elementState.push(...selectedItems);
    if (item.selected) {
      let numberOfRecordsToAssign = 0;
      elementState.forEach(selectedUser => {
        if (selectedUser.userId === item.userId) {
          numberOfRecordsToAssign = selectedUser.numberOfRecordsToAssign;
        }
      });
      item.numberOfRecordsToAssign = numberOfRecordsToAssign;
      elementState.push(Object.assign({}, item));
    } else if (item.userId && item.cardBrandName) {
      let index = elementState.findIndex(o => o.userId == item.userId && o.cardBrandName == item.cardBrandName);
      if (index > -1) {
        elementState.splice(index, 1);
      }
    } else {
      let filterCodeIndex = elementState.findIndex(o => o.id == item.id && o.groupId == item.groupId);
      if (filterCodeIndex > -1) {
        elementState.splice(filterCodeIndex, 1);
      }
    }

    if(filterName == "cq_reason_code" || (filterName == 'reason_code' && filterCodeFilters.elementSequenceNumber == 5)){
      elementState = this.removeDuplicateReasonCodes(elementState);
    } else {
      elementState = Array.from(new Set(elementState));
    }

    this.setState({
      [filterState]: elementState
    });

    return elementState.map((item) => {
      return (filterName == "cq_reason_code" || (filterName == 'reason_code' && filterCodeFilters.elementSequenceNumber == 5)) ? item : item.value;
    });
  }

  searchReasonCode(value, filterName) {
    let updatedFilterName = filterName == undefined && this.state.key ? this.state.key : filterName;
    this.setState({
      [updatedFilterName]: value,	 //defect id 45 => for value getting autometically added for reason code field
      visible: true,
    });
  }

  handleHeaderCheckbox(item, filterName) {
    let newSelection = [];
    let newValues = [];
    let corp = [];
    let region = [];
    let corpRegion = [];
    item.isIndeterminate = false;
    each(item.items, function (user) {
      user.selected = item.selected
      if ((filterName == 'cq_reason_code' || filterName == 'reason_code')  && user.value && !user.value.includes('-')) {
        user.value = user.value + "-" + user.groupId
        user.id = user.id + "-" + user.groupId
      }
    });
    let selectedReasonCode = this.state.selectedReasonCode ? this.state.selectedReasonCode : [];
    let selectedCorpRegionCode = this.state.selectedCorpRegionCode ? this.state.selectedCorpRegionCode : [];
    let reasonCodeFilters = this.state.sortedFilterList.find(sortedFilter => sortedFilter.elementId == 'reason_code');

    if (filterName == 'cq_reason_code' || (filterName == 'reason_code' && reasonCodeFilters.elementSequenceNumber == 5)) {
      newSelection = this.handleHeaderCheckboxCommon(item, filterName, 'selectedReasonCodeCq')
    }
    if (filterName == 'cq_action_code') {
      newSelection = this.handleHeaderCheckboxCommon(item, filterName, 'selectedActionCode');
    }
    if (filterName == 'cq_activity_code') {
      newSelection = this.handleHeaderCheckboxCommon(item, filterName, 'selectedActivityCode');
    }
    if (filterName == 'cq_dspstn_ctgry') {
      newSelection = this.handleHeaderCheckboxCommon(item, filterName, 'selectedDispCategory');
    }
    if (filterName == 'cq_dispute_currency') {
      newSelection = this.handleHeaderCheckboxCommon(item, filterName, 'selectedDisputeCurr');
    }
    if (filterName == 'cq_mcc') {
      newSelection = this.handleHeaderCheckboxCommon(item, filterName, 'selectedMccCode');
    }
    if (filterName == 'cq_trnsctn_currency') {
      newSelection = this.handleHeaderCheckboxCommon(item, filterName, 'selectedTransactionCurr');
    }
    if (filterName == 'cq_sttlmnt_crrncy') {
      newSelection = this.handleHeaderCheckboxCommon(item, filterName, 'selectedSettlementCurr');
    }
    if (filterName == 'idr_disposition') {
      newSelection = this.handleHeaderCheckboxCommon(item, filterName, 'idr_activity_code');
    }
    if (filterName == 'merchant_dspn_actn') {
      newSelection = this.handleHeaderCheckboxCommon(item, filterName, 'merch_disp_code');
    }
    if (filterName == 'idr_action_code') {
      newSelection = this.handleHeaderCheckboxCommon(item, filterName, 'idr_disp_action_code');
    }
    if (filterName == 'un_analyst_name') {
      newSelection = this.handleHeaderCheckboxCommon(item, filterName, 'selectedAnalystName');
    }
    if (filterName != 'corpregion' && filterName !== 'cq_reason_code' && (filterName == 'reason_code' && reasonCodeFilters.elementSequenceNumber !== 5) && filterName !== 'cq_action_code' && filterName !== 'cq_activity_code' && filterName !== 'cq_dspstn_ctgry' && filterName !== 'cq_dispute_currency' && filterName !== 'cq_mcc' && filterName !== 'cq_trnsctn_currency' && filterName !== 'cq_sttlmnt_crrncy' && filterName != 'un_analyst_name') {
      reasonCodeFilters && reasonCodeFilters.filterValues.map((filterValue) => {
        filterValue.items.map(filterItem => {
          if (filterItem.selected) {
            let filterIndex = selectedReasonCode.findIndex((selectedReasonCodeItem) => selectedReasonCodeItem.id == filterItem.id && selectedReasonCodeItem.groupId == filterItem.groupId);
            if (filterIndex == -1 && this.state.currentValues && this.state.currentValues.reason_code && this.state.currentValues.reason_code.v1 && this.state.currentValues.reason_code.v1.findIndex(val => val == filterItem.id) != -1) {
              selectedReasonCode = selectedReasonCode.concat(filterItem);
            }
          }
        })
      })
      selectedReasonCode = Array.from(new Set(selectedReasonCode));
      if (item.selected) {
        item.items.forEach((user) => {
          selectedReasonCode.push(Object.assign({}, user));
        }
        );
      }
      else {
        each(item.items, function (user) {
          let index = selectedReasonCode.findIndex(selectedUser => selectedUser.id == user.id && selectedUser.groupId == user.groupId);
          if (index != -1)
            selectedReasonCode.splice(index, 1);
        });
      }
    }

    if (filterName === 'corpregion') {
      if (item.selected) {
        item.items.forEach((user) => {
          selectedCorpRegionCode.push(Object.assign({}, user));
        });
      }
      else {
        each(item.items, function (user) {
          let index = selectedCorpRegionCode.findIndex(selectedUser => selectedUser.id == user.id && selectedUser.groupId == user.groupId);
          if (index != -1)
            selectedCorpRegionCode.splice(index, 1);
        });
      }

      newSelection = selectedCorpRegionCode.map((item) => {
        return `${item.groupId} - ${item.value}`;
      });
      corp = selectedCorpRegionCode.map((item) => {
        return item.groupId;
      });
      corp = corp.filter((x, i, a) => a.indexOf(x) == i)
      region = selectedCorpRegionCode.map((item) => {
        return item.value;
      });
      corpRegion = selectedCorpRegionCode.map((item) => {
        return { "corp": item.groupId, "region": item.value }
      });
      this.setState({
        corp: corp,
        region: region,
        corpRegion: corpRegion
      })
    } else if (filterName !== 'cq_reason_code' && (filterName == 'reason_code' && reasonCodeFilters.elementSequenceNumber !== 5) && filterName !== 'cq_action_code' && filterName !== 'cq_activity_code' && filterName !== 'cq_dspstn_ctgry' && filterName !== 'cq_dispute_currency' && filterName !== 'cq_mcc' && filterName !== 'cq_trnsctn_currency' && filterName !== 'cq_sttlmnt_crrncy' && filterName != 'un_analyst_name'
    && filterName !== 'merchant_dspn_actn' && filterName !== 'idr_disposition' && filterName !== 'idr_action_code') {
      newSelection = selectedReasonCode.map((item) => {
        return item.value;
      });
    }

    newValues = Object.assign({}, this.state.currentValues, {
      [filterName]: { v1: newSelection },
    });

    this.setState({
      selectedReasonCode: selectedReasonCode,
      currentValues: newValues,
      selectedCorpRegionCode: selectedCorpRegionCode,
    });
  }

  handleHeaderCheckboxCommon = (item, filterName, filterState) => {
    let elementState = this.state[filterState] ? this.state[filterState] : [];
    let filterCodeFilters = this.state.sortedFilterList.find(sortedFilter => sortedFilter.elementId == filterName);
    let selectedItems = [];
    filterCodeFilters && filterCodeFilters.filterValues.map((filterValue) => {
      filterValue.items.map(filterItem => {
        if (filterItem.selected) {
          selectedItems.push(filterItem);
          let filterIndex = elementState.findIndex((selectedCodeItem) => selectedCodeItem.id == filterItem.id && selectedCodeItem.groupId == filterItem.groupId);
          if (filterIndex == -1 && this.state.currentValues && this.state.currentValues[filterName] && this.state.currentValues[filterName].v1 && this.state.currentValues[filterName].v1.findIndex(val => val == filterItem.id) != -1) {
            elementState = elementState.concat(filterItem);
          }
        }
      })
    })
    elementState.push(...selectedItems);
    if (item.selected) {
      item.items.forEach((user) => {
        elementState.push(Object.assign({}, user));
      }
      );
    }
    else {
      each(item.items, function (user) {
        let index = elementState.findIndex(selectedUser => selectedUser.id == user.id && selectedUser.groupId == user.groupId);
        if (index != -1)
          elementState.splice(index, 1);
      });
    }

    if(filterName == "cq_reason_code" || (filterName == 'reason_code' && filterCodeFilters.elementSequenceNumber == 5)){
      elementState = this.removeDuplicateReasonCodes(elementState);
    } else {
      elementState = Array.from(new Set(elementState));
    }
    
    this.setState({
      [filterState]: elementState
    });

    return elementState.map((item) => {
      return (filterName == "cq_reason_code" || (filterName == 'reason_code' && filterCodeFilters.elementSequenceNumber == 5)) ? item : item.value;
    });
  }

  removeDuplicateReasonCodes(elementState) {
   return elementState.reduce((acc, current) => {
      const x = acc.find(item => item.id === current.id && item.groupId === current.groupId);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, [])
  }

  toggleCollapse(item) {
    item.isExpanded = !item.isExpanded;
    this.setState({
      sortedFilterList: [...this.state.sortedFilterList]
    });
  }
  toggleSearchDropDown(key) {
    const sortedFilterList = this.state.sortedFilterList.map((element) => {
      if (element.elementId === key) {
        this.setState({
          key: key,
          visibility: !this.state.visibility,
        })
        return Object.assign({}, element, {
          visibility: !this.state.visibility
        });
      } else {
        this.setState({
          key: key,
          visibility: false,
        })
        return Object.assign({}, element, {
          visibility: false
        });
      }
    })
    this.setState({
      sortedFilterList: sortedFilterList,
    })
  }

  handleOutsideClick(filterId) {
    const sortedFilterList = this.state.sortedFilterList && this.state.sortedFilterList.map((element) => {
      if (filterId == element.elementId) {
        return Object.assign({}, element, {
          visibility: false
        });
      }
      else {
        return Object.assign({}, element, {
        });
      }
    });

    this.setState({}, () => {
      this.setState({
        sortedFilterList: sortedFilterList,
        [filterId]: ""
      })
    })
  }
  updateMerchantList(filters,manualSearchMid,row){
          if(this.props.canViewEvoAccountsSelector || this.props.canViewGpnAccountsSelector||this.props.canViewHpyAccountsSelector){
            let selectedHierarchies = {v1:filters};
            let newValues = {
              ...this.state.currentValues,
              selectedHierarchies,
              manualSearchMid,
              row,
            };
            this.setState({
              currentValues:newValues,
              selectedHierarchies,
              merchantHierarchyRest:false,
              selectedRow : row,
            })

          } else if(this.props.canViewHierarchySelector){
            let merchant_hierarchy={v1:filters};
            let newValues = Object.assign({}, this.state.currentValues, {
              merchant_hierarchy,
            });
            this.setState({
              currentValues:newValues,
              merchant_hierarchy,
              merchantHierarchyRest:false,
            })
          }        
  }
  displaySingleListSelector(buttonText, removeDivClass) {
    return (
      <OutsideClickHandler onClickOutside={this.handleClickOutside}>
        <div className={removeDivClass ? "single-list-selector-margin" : "center-align-list-selector"}>
          {this.state.availableFilters.length > 0 && <DashedButton   //defect id 48 => for Add another Filter' option disable after all filters in drop down getting added
            extraClass="dashed-button-width"
            action={() => { this.openSingleListSelector(); }}
            style={removeDivClass ? { width: '192%' } : { width: '29%' }}
          >
            {buttonText}
          </DashedButton>}
          {this.state.isSingleListSelectorOpen && (
            <SingleListSelector
              id={`${this.props.title}_DualListSelector`}
              onRef={(ref) => (this.child = ref)}
              availableColumns={this.state.availableFilters}
              activeColumns={this.state.sortedFilterList}
              extraClass=" "
              isDialog
              translations={this.props.translations}
              updateColumnsInfo={this.props.updateColumnsInfo}
            />

          )}
        </div>
      </OutsideClickHandler>
    )
  }

  closeBanner() {
    this.setState({
        isRangeValidation: false,
        currentValues : [],
    })
}

setArchivalFlag(){
  console.log("Checkbox Test successfully completed");
  this.setState({
   isArchival:!this.state.isArchival,

  });
}

  applyButtonDisabledLogic = () => {
    let currentValues = this.state.currentValues;
    let activeFilterValues = this.props.activeFilters != null ? this.props.activeFilters : [];
    let state = [];

    activeFilterValues.forEach(item => {
      if (currentValues[item.updatedId]?.v1?.length > 0 || (item.elementTypeName == "TWO_MULTISELECT" && currentValues[item.updatedId]?.v2?.length > 0) ) {
        state.push("true");
      } else {
        state.push("false");
      }
    })
    if (state.includes("false")) {
      this.props.disableSaveButton();
      return true
    }

    // FROM-TO value validations
    let toFromFieldsState = [];
    this.state?.sortedFilterList?.filter(item => item?.elementCategoryName == "FROM-TO" && item?.elementTypeName == "CURRENCYRANGE")
      .forEach(item => {
        let element = currentValues[item.elementId];
        if (!(element?.v1?.length > 0 || element?.v2?.length > 0)) { // v1 and v1 empty then update btn enabled
          return false;
        } else {
          if (element?.v1?.length > 0 && element?.v2?.length > 0) {
            toFromFieldsState.push("true");
          } else {
            toFromFieldsState.push("false");
          }
        }
      })
    if (toFromFieldsState.includes("false")) {
      this.props.disableSaveButton();
      return true;
    }

    // default conditon ( switch not used because  "elementCategoryName" and "elementTypeName" need to check)
    return false;

  }

  render() {
    const acquirerCode=JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
    const externalUsers = ['DiMS_ACCOUNT_ADMIN', 'DiMS_ACCOUNT_USER','DiMS_ACQUIRER_ADMIN','DiMS_ACQUIRER_USER','DiMS_HPY_ACCOUNT_USER'];
    const isExternalUser = externalUsers.indexOf(this.state.roleName) !== -1;
    const wrapperClass = classnames('filter-pane', {
      [this.props.extraClass]: this.props.extraClass,
      hidden: !this.props.isVisible,
      show: this.props.isVisible,
      push: this.props.pushFilterPane,
    });

    const filterPaneContentClass = classnames('filter-pane__content', {
      more: this.state.showMoreFilters,
      base: !this.state.showMoreFilters,
    });

    const moreLessText = (this.state.showMoreFilters)
      ? this.props.translations.less
      : this.props.translations.more;

    const { reportName, translations } = this.props;    
    const globalFilter = this.state.merchant_hierarchy ?this.state.merchant_hierarchy.v1:undefined
    const globalFilterAccounts = this.state.selectedRow ? this.state.selectedRow :undefined
    return (
      <div id="filter-pane" className={wrapperClass}>
        <div className={filterPaneContentClass}>
          {
            this.state.visibleCount === 0 && this.props.showDynamicFilter && this.props.activeFilters !== undefined && this.props.activeFilters.length === 0 && (
              <div style={{ padding: '15px' }}>
                <div className="center-align">
                  <h1>Add Your First Filter</h1>
                  <span style={{color:`${COLORS.oneGp.charcoal}`}}>
                    To begin filtering the list of cases below, click the <strong className="text-color">Add a Filter</strong><br />
                    button and select what data you'd like to filter by.
                  </span>
                </div>
                {this.displaySingleListSelector('+ Add a Filter', false)}
              </div>
            )
          }
          {this.props.canViewHierarchySelector &&
          <GlobalSelector
          hideApplyButtons={true}
          enableAddMoreButton={false}
          merchantSelector={true}
          currentFilter={globalFilter}
          updateMerchantList={this.updateMerchantList}
          prepopulatedMerchantId={this.props.prepopulatedMerchantId}
          merchantHierarchyRest={this.state.merchantHierarchyRest}
          onSelectMerchant={this.props.handleMIDSearch}
          />}{ (this.props.canViewEvoAccountsSelector  || this.props.canViewGpnAccountsSelector||this.props.canViewHpyAccountsSelector) &&
          <GlobalSelectorAccounts
           hideApplyButtons={true}
           enableAddMoreButton={false}
           merchantSelector={true}
           currentFilter={globalFilterAccounts}
           updateMerchantList={this.updateMerchantList}
           prepopulatedMerchantId={this.props.prepopulatedMerchantId}
           merchantHierarchyRest={this.state.merchantHierarchyRest}
           onSelectMerchant={this.props.handleMIDSearch}
           canViewGpnAccountsSelector={this.props.canViewGpnAccountsSelector}
           canViewEvoAccountsSelector={this.props.canViewEvoAccountsSelector}
           canViewHpyAccountsSelector={this.props.canViewHpyAccountsSelector}
           canViewHierarchySelector={this.props.canViewHierarchySelector}
           prepopulatedHierarchyValues={this.props.prepopulatedHierarchyValues}
            />
           }
          <div className="filter-input-container">
          {
            // <WizardAccordion
            //   headerText={translations.reportHierarchy}
            //   isOpen={true}
            //   toggleAccordion={this.toggleAccordion}
            //   id="global-selector"
            //   width='100%'
            // >
            //   {
               
              }
            {/* </WizardAccordion>} */}
            {this.displayFilterList}
            {
              this.state.visibleCount > 0
              && this.props.showDynamicFilter
              && this.displaySingleListSelector('+ Add Another Filter', true)
            }
          </div>
        </div>

        {(this.state.visibleCount > 9) && !this.props.hideMoreLessButton === true ?
          <div className="toggle-breakline">
            <PrimaryButton
              action={this.toggleFilters}
              extraClass={"btn-breakline btn-breakline_"+acquirerCode}
              iconDirection="right"
              icon={this.state.showMoreFilters ? TriangleUp : TriangleDown}
              id={`${reportName}_btn_${moreLessText}`}
            >
              {moreLessText}
            </PrimaryButton>
          </div>
          : ''
        }
        {this.props.isCaseSearchPage &&  isExternalUser &&
          <div style={{ padding: '10px 30px 10px 30px' }} >

          <TableCheckbox
              label={counterpart('globalTranslate.caseSearch.archiveFlag')}
              id={"S"}
              isChecked={this.state.isArchival}
              isNotification={true}
              // disabled={!this.state.isToggleChecked}
              onChange={this.setArchivalFlag}

            /> 
            {/* navIcon={true} */}
            <InformationBubble
                id={"H"}
                info
                tooltipContent={counterpart('globalTranslate.caseSearch.archiveToolTip')}
            />
            <div style={{'color':'#9a9fac'}}>{counterpart('globalTranslate.caseSearch.archiveMessage')}</div>
        </div>
        }
            {this.state.tempVariable && (
              <ImagePortal>
              <ResponseBanner
                titleStyle={{ color: 'light-green' }}
                descriptionStyle={{ color: 'grey' }}
                valueStyle={{ color: 'black' }}
                title="Validation Error"
                description={this.state.bannerDescription}
                type="danger"
                onClose={this.closeTempBanner}
                cancelButtonText="DISMISS"
                primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
                primaryButtonAction={this.closeTempBanner}
              />
               </ImagePortal>
            )}
          

        <div className="filter-pane__footer">
          <Button
            action={this.clearFilters}
            extraClass="clear-filters"
            category="link-inline"
            id={`${reportName}_btn_clear`}
          >
            <strong> {translations.clearFilterPane}</strong>
          </Button>
          <div className="filter-pane__footer-right" >
            <Button
              action={this.props.closeFilterPane}
              extraClass="filter-pane__close-button"
              id={`${reportName}_btn_cancel`}
              style={this.props.cancelButtonStyle}
            >
              <strong style={{color:'#262aff'}}>{translations.cancel}</strong>
            </Button>
              {/* { this.props.showApplyAndSave == "ProductivityReport" && <span style={{marginRight: "10px"}}>
                <HollowClearButton
                  action={this.saveAndApplyFilters}
                  extraClass="apply-save-button"
                  id={`${reportName}_btn_applyAndSave`}
                  disabled={this.state.sortedFilterList.length > 0 ? false : true}
                >
                  <strong> {"Apply & Save"}</strong>
                </HollowClearButton>
              </span>} */}
              <span>
                <PrimaryButton
                  action={this.applyFilters}
                  extraClass="filter-pane__apply-button"
                  id={`${reportName}_btn_apply`}
                  style={this.props.primaryButtonStyle}
                  disabled={this.state.sortedFilterList.length > 0 && !this.state.enableApplyButton ? false : true}
                >
                  <strong> {translations.applyFilterPane}</strong>
                </PrimaryButton>
              </span>
          </div>
        </div>
        {this.state.isRangeValidation &&
        <ImagePortal>
            <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title="Validation Error"
            description="Please select range between 45 days"
            type="danger"
            onClose={this.closeBanner}
            cancelButtonText="DISMISS"
            primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
            primaryButtonAction={this.closeBanner}
            ></ResponseBanner>
            </ImagePortal>
        }
      </div>
    );
  }
  
}

FilterPane.propTypes = {
  applyFilters: PropTypes.func.isRequired,
  closeFilterPane: PropTypes.func.isRequired,
  currentValues: PropTypes.array,
  dateFormat: PropTypes.string.isRequired,
  extraClass: PropTypes.string,
  filterList: PropTypes.array.isRequired,
  isVisible: PropTypes.bool,
  pushFilterPane: PropTypes.bool,
  reportName: PropTypes.string,
  reportKey: PropTypes.string,
  translations: PropTypes.object,
  language: PropTypes.string, 
  setAlertPrefs: PropTypes.func,
  deleteAlertPrefsByAlertkey: PropTypes.func,
  callOnBoardContainer: PropTypes.bool,
  resetScrollPos: PropTypes.func.isRequired,
  showDynamicFilter: PropTypes.bool,
  availableFilters: PropTypes.array,
  updateColumnsInfo: PropTypes.func,
  userPermission: PropTypes.object,
  isInvBreReport: PropTypes.bool,
  applyAuto: PropTypes.bool,
  disableSaveButton: PropTypes.func,
  isCaseSearchPage: PropTypes.bool,
  canViewEvoAccountsSelector: PropTypes.bool,
  showRemoveLabel : PropTypes.bool,
};

FilterPane.defaultProps = {
  userPermission: {},
  currentValues: [],
  setAlertPrefs: () => { },
  deleteAlertPrefsByAlertkey: () => { },
  extraClass: '',
  filterList: [],
  isVisible: false,
  pushFilterPane: false,
  reportName: '',
  reportKey: '',
  translations: {
    apply: 'Apply',
    cancel: 'Cancel',
    clear: 'Clear',
    less: 'Less',
    more: 'More',
  },
  callOnBoardContainer: true,
  showDynamicFilter: false,
  availableFilters: [],
  updateColumnsInfo: () => { },
  isExpanded: false,
  selectedCard: () => { },
  visibleFiltersCount: 12,
  onFilterValueChange: () => { },
  isInvBreReport: false,
  applyAuto: false,
  disableSaveButton: () => { },
  canViewEvoAccountsSelector: false,
  showRemoveLabel : true 
};

export default FilterPane;
